import React, { useContext, useState } from 'react'
import { CircleSpinner } from 'shared/index'
import {
	completeUserUpdate,
	deriveUserUpdateError,
} from 'selfServicePortal/services/CustomerServices/updateUserService'
import { useMutation } from '@tanstack/react-query'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { OtpInput } from 'selfServicePortal/components/OtpInput/OtpInput'
import { useTranslation } from 'react-i18next'
import { isAxiosError, getErrorMessage } from 'selfServicePortal/utils'
import { Heading } from 'selfServicePortal/components'
import { ContactOtpLength } from '../MyAccount'

interface AddressOtpProps {
	sessionId: string | undefined
	onSuccess: () => void
}

export function AddressOtp({ sessionId, onSuccess }: AddressOtpProps) {
	const { t } = useTranslation()
	const { customerData, isCard } = useContext(SspContext)
	const [otp, setOtp] = useState('')
	const completeUserUpdateMutation = useMutation(
		() =>
			completeUserUpdate({
				customerId: customerData?.customerId,
				sessionId,
				otpCode: otp,
			}),
		{ onSuccess: onSuccess },
	)

	const isDeposit = !isCard?.isCard

	if (completeUserUpdateMutation.isLoading) {
		return <CircleSpinner />
	}

	return (
		<>
			<Heading
				title={t('AddressChangeOtpTitle')}
				description={t('AddressChangeOtpDescription')}
			/>

			<OtpInput value={otp} onChange={setOtp} />

			{completeUserUpdateMutation.isError && (
				<div className="error">
					{isAxiosError(completeUserUpdateMutation.error)
						? deriveUserUpdateError(
								completeUserUpdateMutation.error.response?.data
									.message,
								isDeposit,
						  )
						: getErrorMessage(completeUserUpdateMutation.error)}
				</div>
			)}
			<div>
				<button
					type="button"
					className="btn btn-primary"
					disabled={otp.length !== ContactOtpLength}
					onClick={() => completeUserUpdateMutation.mutate()}>
					{t('AddressChangeButton')}
				</button>
			</div>
		</>
	)
}
